import Image from 'next/image';
import styles from './TreatmentSummary.module.css';
import { ICaseStudyDetails } from '@/interfaces';
type props = {
    caseStudyData: ICaseStudyDetails
}
export function TreatmentSummary({ caseStudyData }: props) {
    return (
        <section className={`${styles.treatmentSummary} mb30`}>
            <div className="container">
                <h2 className="sectionHeading">Treatment Summary</h2>
                <div className={styles.treatmentSummary_sec}>
                    <div className={styles.treatmentSummary_box}>
                        <figure>
                            <Image src="/assets/images/treatmentUser1.png" width={41} height={41} className="imgResponsive" alt="" />
                        </figure>
                        <div className={`${styles.treatmentSummary_title} font16 fontRegular text666`}>
                            Patient Profile
                        </div>
                        <div className={`${styles.treatmentSummary_content} font16 fontMedium text46675`}>
                           {caseStudyData?.treatment?.patient_profile}
                        </div>
                    </div>
                    <div className={styles.treatmentSummary_box}>
                        <figure>
                            <Image src="/assets/images/treatmentDiagnosis2.png" width={41} height={41} className="imgResponsive" alt="" />
                        </figure>
                        <div className={`${styles.treatmentSummary_title} font16 fontRegular text666`}>
                            Diagnosis
                        </div>
                        <div className={`${styles.treatmentSummary_content} font16 fontMedium text46675`}>
                            {caseStudyData?.treatment?.diagnosis}
                        </div>
                    </div>
                    <div className={styles.treatmentSummary_box}>
                        <figure>
                            <Image src="/assets/images/treatmentCalendar3.png" width={41} height={41} className="imgResponsive" alt="" />
                        </figure>
                        <div className={`${styles.treatmentSummary_title} font16 fontRegular text666`}>
                            Duration of Treatment
                        </div>
                        <div className={`${styles.treatmentSummary_content} font16 fontMedium text46675`}>
                            {caseStudyData?.treatment?.treatment_duration}
                        </div>
                    </div>
                    <div className={styles.treatmentSummary_box}>
                        <figure>
                            <Image src="/assets/images/treatmentDoctor4.png" width={41} height={41} className="imgResponsive" alt="" />
                        </figure>
                        <div className={`${styles.treatmentSummary_title} font16 fontRegular text666`}>
                            Suggestions by Doctor
                        </div>
                        <div className={`${styles.treatmentSummary_content} font16 fontMedium text46675`}>
                            {caseStudyData?.treatment?.doctor_suggestion}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}